module.exports = __webpack_public_path__ + "static/sanpaolo-b815f507917fcfe74ade1c864d0b702d.png";